import { ITreeItem, StyledTreeItem } from './TreeItem';

export const TreeViewItem = (props: ITreeItem): JSX.Element => {
  return (
    <StyledTreeItem
      {...props}
      onClick={() => {
        props.treeitemclick && props.treeitemclick(props.nodeId);
      }}
    >
      {props.child && props.child.map((item, i) => <TreeViewItem key={i} {...item} treeitemclick={props.treeitemclick} />)}
    </StyledTreeItem>
  );
};
